<template>
  <div>
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="650"
      persistent
      scrollable
    >
      <v-card v-if="selectedOrder">
        <v-toolbar
          class="pink accent-3"
          flat
          height="80"
          max-height="80"
        >
          <v-avatar color="pink darken-3">
            <v-icon
              v-if="selectedOrder.SourceTypeId<100"
              color="white"
              size="28"
            >
              {{ getOrderSourceTypeById(selectedOrder.SourceTypeId).logo }}
            </v-icon>

            <img
              v-else
              :src="getOrderSourceTypeById(selectedOrder.SourceTypeId).logo"
              style="width: 32px; height: auto;"
            >
          </v-avatar>

          <v-toolbar-title class="pl-3 white--text">
            <div class="body-3">
              {{ $t('Order.OrderChangeStatusDialog.CancelOrder.Title') }}
            </div>

            <div class="text-caption red--text text--lighten-4">
              {{ parseInt(selectedOrder.SourceTypeId) >= 100 ? getOrderSourceTypeById(selectedOrder.SourceTypeId).desc : getOrderSourceTypeLangById(selectedOrder.SourceTypeId).Desc }}
              #{{ selectedOrder.OrderCode }}
            </div>
          </v-toolbar-title>

          <v-spacer />
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-3">
          <v-container
            class="pa-1"
            fluid
          >
            <v-row dense>
              <v-col
                class="mb-1"
                cols="12"
              >
                <span class="text-subtitle-1">
                  {{ $t('Order.OrderChangeStatusDialog.CancelOrder.Subtitle.Order') }}
                  <strong>#{{ selectedOrder.OrderCode }}</strong> {{ $t('Order.OrderChangeStatusDialog.CancelOrder.Subtitle.CancelPermanently') }}
                </span>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col
                cols="12"
                sm="8"
              >
                <v-container
                  class="pa-0"
                  fluid
                >
                  <v-row no-gutters>
                    <v-col
                      cols="4"
                      sm="4"
                    >
                      <span :class="isDarkMode ? 'white--text' : 'black--text'">
                        {{ $t('Order.OrderChangeStatusDialog.Field.Name').toLocaleUpperCase($i18n.locale) }}
                      </span>
                    </v-col>
                    <v-col
                      class="grey--text text--darken-1"
                      cols="8"
                      sm="8"
                    >
                      {{ (parseInt(selectedOrder.CustomerId) !== 0 || selectedOrder.FullName !== 'null null') ? selectedOrder.FullName : $t('Customer.CustomerType.Visitor') }}
                    </v-col>

                    <v-col
                      cols="4"
                      sm="4"
                    >
                      <span :class="isDarkMode ? 'white--text' : 'black--text'">
                        {{ $t('Order.OrderChangeStatusDialog.Field.Telephone').toLocaleUpperCase($i18n.locale) }}
                      </span>
                    </v-col>
                    <v-col
                      class="grey--text text--darken-1"
                      cols="8"
                      sm="8"
                    >
                      {{ selectedOrder.Telephone }}
                    </v-col>

                    <v-col
                      cols="4"
                      sm="4"
                    >
                      <span :class="isDarkMode ? 'white--text' : 'black--text'">
                        {{ $t('Order.OrderChangeStatusDialog.Field.Time').toLocaleUpperCase($i18n.locale) }}
                      </span>
                    </v-col>
                    <v-col
                      class="grey--text text--darken-1"
                      cols="8"
                      sm="8"
                    >
                      {{ selectedOrder.TimeAdded }}
                    </v-col>

                    <v-col
                      cols="4"
                      sm="4"
                    >
                      <span :class="isDarkMode ? 'white--text' : 'black--text'">
                        {{ $t('Order.OrderChangeStatusDialog.Field.Total').toLocaleUpperCase($i18n.locale) }}
                      </span>
                    </v-col>
                    <v-col
                      class="grey--text text--darken-1"
                      cols="8"
                      sm="8"
                    >
                      <span
                        :class="isDarkMode ? 'white--text' : 'black--text'"
                        class="text-subtitle-1 font-weight-bold"
                      >{{ selectedOrder.Price | currency }}</span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>

              <v-col
                cols="12"
                sm="4"
              >
                <v-container
                  class="pa-0"
                  fluid
                >
                  <v-row dense>
                    <v-row dense>
                      <v-col cols="12">
                        <order-status-chip
                          :order="selectedOrder"
                          dense
                          min-width="190"
                        />
                      </v-col>

                      <v-col cols="12">
                        <order-type-chip
                          :order="selectedOrder"
                          dense
                          label
                          min-width="190"
                        />
                      </v-col>

                      <v-col cols="12">
                        <order-payments-chip
                          :item="selectedOrder"
                          dense
                          min-width="190"
                        />
                      </v-col>
                    </v-row>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-0">
          <v-container
            class="pa-0"
            fluid
          >
            <v-row no-gutters>
              <v-col
                :class="isDarkMode ? 'red lighten-2' : 'red lighten-4'"
                cols="12"
              >
                <div
                  class="py-2 px-4 text-caption"
                  style="display: table;"
                >
                  <div style="display: table-row">
                    <div
                      class="font-weight-bold pr-2"
                      style="display: table-cell; vertical-align: top;"
                    >
                      {{ $t('Common.Misc.Attention').toLocaleUpperCase($i18n.locale) }}:
                    </div>

                    <div style="display: table-cell; vertical-align: middle;">
                      <div
                        v-if="selectedOrder.Reserved > 0 && selectedOrder.Reserved !== parseInt(posUser.staff_id)"
                        style="vertical-align: middle;"
                      >
                        <v-icon
                          class="pl-0 mr-1"
                          color="orange"
                          size="18"
                        >
                          lock
                        </v-icon>
                        &#8226; <span>{{ $t('Order.OrdersSaved.ListView.EditedBy') }} {{ selectedOrder.ReservedName }}</span> <br class="hidden-xs-only">
                      </div>

                      <div :class="{'pl-6': selectedOrder.Reserved > 0 && selectedOrder.Reserved !== parseInt(posUser.staff_id)}">
                        <div v-safe-html="`&#8226; ${$t('Order.OrderChangeStatusDialog.Notification.Title')}`" />

                        <div
                          v-if="selectedOrderIsRefundable"
                          v-safe-html="`&#8226; ${$t('Order.OrderChangeStatusDialog.Notification.Amount')} ${$options.filters.currency(selectedOrderRefundableAmount) } ${$t('Order.OrderChangeStatusDialog.Notification.Refund')}`"
                          class="mt-1"
                        />

                        <div
                          v-if="selectedOrderHasFiscalDocument && orderLatestFiscalDocument(selectedOrder)"
                          v-safe-html="`&#8226; ${FiscalDocTypeEnum.isReceipt(orderLatestFiscalDocument(selectedOrder)?.ReceiptType) ? $t('Order.OrderChangeStatusDialog.Notification.Receipt') : $t('Order.OrderChangeStatusDialog.Notification.Invoice')}`"
                          class="mt-1"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn
            class="green--text text--darken-1"
            outlined
            text
            @click.native="isVisible = false"
          >
            {{ $t('Common.Button.No').toLocaleUpperCase($i18n.locale) }}
          </v-btn>

          <v-btn
            class="pink darken-1 white--text"
            text
            @click.exact="cancelOrder()"
            @click.native="isVisible = false"
          >
            {{ $t('Common.Button.Yes').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Auth from '@/mixins/auth'
import AppData from '@/mixins/appdata'
import OrderType from '@/mixins/orders/orderType'
import SourceType from '@/mixins/orders/sourceType'
import OrderStatusColor from '@/mixins/orders/orderStatus'
import OrderTypeTime from '@/mixins/orders/orderTypeTime'
import OrderTypeChip from '@/components/orders/common/OrderTypeChip'
import OrderStatusChip from '@/components/orders/common/OrderStatusChip'
import OrderPaymentsChip from '@/components/orders/common/OrderPaymentsChip'
import OrderReceipts from '@/mixins/orders/orderReceipts'
import OrderTransactions from '@/mixins/orders/orderTransactions'
import FiscalDocTypeEnum from '@/api/Enums/FiscalDocTypeEnum'

export default {
  components: {
    OrderStatusChip,
    OrderTypeChip,
    OrderPaymentsChip
  },
  mixins: [AppData, Auth, OrderStatusColor, OrderType, OrderReceipts, OrderTransactions, SourceType, OrderTypeTime],
  props : {
    cancelOrderConfirmDialogVisible: {
      type   : Boolean,
      default: false
    },
    selectedOrder: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {}
  },
  computed: {
    FiscalDocTypeEnum() {
      return FiscalDocTypeEnum
    },
    selectedOrderIsRefundable() {
      return this.orderIsRefundable(this.selectedOrder)
    },

    selectedOrderRefundableAmount() {
      return this.orderRefundableAmount(this.selectedOrder)
    },

    selectedOrderHasFiscalDocument() {
      return this.orderHasFiscalDocument(this.selectedOrder)
    },

    isVisible: {
      get() {
        return this.cancelOrderConfirmDialogVisible
      },
      set(val) {
        this.$emit('update:cancelOrderConfirmDialogVisible', val)
      }
    }
  },
  methods: {
    cancelOrder() {
      if (this.$route.name === 'OrdersSaved') {
        window.callAS(window.SocketCommand.Cart.Destroy, {CartId: this.selectedOrder.Id})
      } else {
        window.callAS(window.SocketCommand.Order.Cancel, {
          order_id       : this.selectedOrder.Id || null,
          status_id      : this.selectedOrder.StatusId || null,
          receipt_id     : this.orderLatestFiscalDocument(this.selectedOrder)?.ReceiptId || null,
          order_type_time: this.selectedOrder.OrderTypeTime
        }, window.SocketCommand.Order.StatusUpdated)
        this.$bus.$emit('order-canceled', this.selectedOrder)
      }
    }
  }
}
</script>
